module.exports = __webpack_public_path__ + "img/educationalTraining3.006d0244.png";